import TickText from '../../TickText';

export const YAxisTick = ({ payload, ...props }) => {
  return <TickText {...props}>{payload.value}</TickText>;
};
